module.exports = __webpack_public_path__ + "img/20220624111123.b14b38e2.png";